import React from "react";
import "../../stylesheet/components/singlecomponents/Modal.scss";

type ModalProps = {
  targetElementName: string;
  ClassName?: string;
  children: React.ReactNode;
  backdrop?: boolean;
};

const Modal: React.FC<ModalProps> = ({
  targetElementName,
  children,
  ClassName,
  backdrop = true,
}) => {
  return (
    <div
      className={`modal fade ${ClassName ? ClassName : ""}`}
      tabIndex={-1}
      id={targetElementName}
      data-bs-backdrop={backdrop ? "static" : "false"}
      data-bs-keyboard="false"
      aria-labelledby={targetElementName}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header border-0 pt-3 pb-1">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
